import {
  ProfileDto,
  ProfileLiteView,
  ProfileView,
} from "admin/src/server/mappers/profile/profile";

export const getDisplayNameHelper = (
  profile: ProfileDto | ProfileView | ProfileLiteView,
): string => {
  // Check if displayName exists and is not an empty string
  if (
    profile.societyUser?.displayName &&
    profile.societyUser.displayName !== ""
  ) {
    return profile.societyUser.displayName;
  }
  if (profile.societyUser?.firstName && profile.societyUser.lastName) {
    return `${profile.societyUser.firstName} ${profile.societyUser.lastName}`;
  }
  if (profile.institution?.name) {
    return profile.institution.name;
  }
  return "UNKNOWN";
};
